import { Link, PageRendererProps } from "gatsby";
import React, { useState, useEffect } from "react";

const Header = ({ location }: PageRendererProps) => {
  const getsbyLogo = require("../images/getsby_logo_grey.svg");
  const [scrollPosition, setSrollPosition] = useState<number>(0);

  const inactiveClass = "inline-block no-underline";
  const activeClass = "rounded-full shadow-lg bg-white";

  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;

      setSrollPosition(position);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={`gradient p-2 mt-0 fixed w-full z-50 top-0 ${
        scrollPosition > 0 ? "shadow" : ""
      }`}
    >
      <div className="container mx-auto flex flex-wrap items-center">
        <div className="flex w-full md:w-1/2 justify-center md:justify-start">
          <Link to="/" className="no-underline">
            <img
              className="mr-2"
              src={getsbyLogo}
              alt="getsby"
              style={{ width: "auto", height: "56px" }}
            />
          </Link>
        </div>
        <div className="flex w-full pt-2 content-center justify-between md:w-1/2 md:justify-end">
          <ul className="list-reset flex justify-between flex-1 md:flex-none items-center">
            <li>
              <Link
                className={`py-2 px-4 text-gray-800 font-bold flex-no-wrap
                  ${
                    location.pathname.length === 1 ? activeClass : inactiveClass
                  }
                `}
                to="/"
              >
                Für Gäste
              </Link>
            </li>
            <li>
              <Link
                className={`py-2 px-4 text-gray-800 font-bold
                  ${
                    location.pathname.match("/partner")
                      ? activeClass
                      : inactiveClass
                  }`}
                to="/partner"
              >
                Für Partner
              </Link>
            </li>
            {/*
            <li>
              <Link
                className={`py-2 px-4 text-gray-800 font-bold
                  ${
                    location.pathname.match("/imprint")
                      ? activeClass
                      : inactiveClass
                  }`}
                to="/imprint"
              >
                Impressum
              </Link>
            </li>
            */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
